import React from "react";

import Container from "../../Components/Container";
import BGImageDisplay from "../../Components/BGImageDisplay/BGImageDisplay";
import BG from "./PageOne/assets/AccoladesIMG@2x.png";

const Accolades = () => {
  return (
    <Container>
      <BGImageDisplay bgimage={BG}></BGImageDisplay>
    </Container>
  );
};

export default Accolades;
